import { render, staticRenderFns } from "./WsHeader.vue?vue&type=template&id=722c934e"
import script from "./WsHeader.vue?vue&type=script&lang=js"
export * from "./WsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports